/* eslint-disable */
import React, { useState } from 'react';
import Select from 'react-select';
import DashboardSection from '../../DashboardContainer/DashboardSection';
import DomainTile from '../../DomainTile/DomainTile';
import ReusableTable from '../../ReusableTable/ReusableTable';
import styles from './AgratasBankReconciliation.module.css';

const geographyOptions = [
  { value: 'All', label: '(All)' },
  { value: 'domastic', label: 'Domastic' },
  { value: 'international', label: 'International' },
];

const yearOptions = [
  { value: 'All', label: '(All)' },
  { value: '2025', label: '2025' },
  { value: '2024', label: '2024' },
];

const quarterOptions = [
  { value: 'All', label: '(All)' },
  { value: 'Q1', label: 'Q1' },
  { value: 'Q2', label: 'Q2' },
  { value: 'Q3', label: 'Q3' },
  { value: 'Q4', label: 'Q4' },
];

const entityOptions = [
  { value: 'undefined', label: 'Select' },
  { value: 'All', label: '-All-' },
  { value: 'tmcv', label: 'TMCV' },
  { value: 'tmpv', label: 'TMPV' },
  { value: 'jlr', label: 'JLR' },
  { value: 'agratas', label: 'Agratas' },
];

const monthOptions = [
  { value: 'All', label: '(All)' },
  { value: 'Jan', label: 'Jan' },
  { value: 'Feb', label: 'Feb' },
  { value: 'Mar', label: 'Mar' },
  { value: 'Apr', label: 'Apr' },
  { value: 'May', label: 'May' },
  { value: 'Jun', label: 'Jun' },
  { value: 'Jul', label: 'Jul' },
  { value: 'Aug', label: 'Aug' },
  { value: 'Sep', label: 'Sep' },
  { value: 'Oct', label: 'Oct' },
  { value: 'Nov', label: 'Nov' },
  { value: 'Dec', label: 'Dec' },
];

const WeekOptions = [
  { value: 'undefined', label: 'Select' },
  { value: 'All', label: '-All-' },
  ...Array.from({ length: 52 }, (_, i) => ({
    value: `W${i + 1}`,
    label: `Week ${i + 1}`
  }))
];


const AgratasBankReconcilation = () => {
  const [entity, setEntity] = useState(yearOptions[0]);
  const [geography, setgeography] = useState(yearOptions[0]);
  const [year, setYear] = useState(yearOptions[0]);
  const [quarter, setQuarter] = useState(quarterOptions[0]);
  const [month, setMonth] = useState(monthOptions[0]);
  const [week, setWeek] = useState(WeekOptions[0]);

  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [page, setPage] = useState(1);
  const itemsPerPage = 10;
  const [selectedPage, setSelectedPage] = useState(1);

  const handleApply = () => {
    console.log('Apply clicked with:', {
      year: year.value,
      quarter: quarter.value,
      month: month.value,
    });
  };

  const handleCSVDownload = () => {
    const csvHeader = columns.map(col => col.header).join(',');
    const csvRows = data.map(row =>
      columns.map(col => `"${(row[col.accessor] || '').replace(/"/g, '""')}"`).join(',')
    );
    const csvContent = [csvHeader, ...csvRows].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'legal_disputes.csv';
    link.click();
  };

  const handleReset = () => {
    setYear(yearOptions[0]);
    setQuarter(quarterOptions[0]);
    setMonth(monthOptions[0]);
  };

  const columns = [
    { header: "Sr. No.", accessor: "srNo" },
    { header: "Document Number", accessor: "Dname" },
    { header: "Document Name", accessor: "entityName" },
    { header: "Document Type", accessor: "country" },
    { header: "Bank", accessor: "DnameHolder" },
    { header: "Amount", accessor: "DReg" },
    { header: "Ageing", accessor: "action" },
    { header: "Action Owner", accessor: "comments" },
    { header: "Remarks", accessor: "comments" }

  ];

  const data = [
    { "srNo": 1, "Dname": "abc.com", "entityName": "TMPV", "country": "India", "DnameHolder": "abc", "DReg": "123", "action": "test name", "comments": "" },
    { "srNo": 2, "Dname": "def.com", "entityName": "TMCV", "country": "India", "DnameHolder": "abc", "DReg": "123", "action": "test name", "comments": "" },
    { "srNo": 3, "Dname": "abc.com", "entityName": "TML", "country": "India", "DnameHolder": "abc", "DReg": "123", "action": "test name", "comments": "" },
    { "srNo": 4, "Dname": "abc.com", "entityName": "TML", "country": "India", "DnameHolder": "abc", "DReg": "123", "action": "test name", "comments": "" },
    { "srNo": 5, "Dname": "abc.com", "entityName": "TML", "country": "India", "DnameHolder": "abc", "DReg": "123", "action": "test name", "comments": "" },
    { "srNo": 1, "Dname": "abc.com", "entityName": "TMPV", "country": "India", "DnameHolder": "abc", "DReg": "123", "action": "test name", "comments": "" },
    { "srNo": 2, "Dname": "def.com", "entityName": "TMCV", "country": "India", "DnameHolder": "abc", "DReg": "123", "action": "test name", "comments": "" },
    { "srNo": 3, "Dname": "abc.com", "entityName": "TML", "country": "India", "DnameHolder": "abc", "DReg": "123", "action": "test name", "comments": "" },
    { "srNo": 4, "Dname": "abc.com", "entityName": "TML", "country": "India", "DnameHolder": "abc", "DReg": "123", "action": "test name", "comments": "" },
    { "srNo": 5, "Dname": "abc.com", "entityName": "TML", "country": "India", "DnameHolder": "abc", "DReg": "123", "action": "test name", "comments": "" },
    { "srNo": 1, "Dname": "abc.com", "entityName": "TMPV", "country": "India", "DnameHolder": "abc", "DReg": "123", "action": "test name", "comments": "" },
    { "srNo": 2, "Dname": "def.com", "entityName": "TMCV", "country": "India", "DnameHolder": "abc", "DReg": "123", "action": "test name", "comments": "" },
    { "srNo": 3, "Dname": "abc.com", "entityName": "TML", "country": "India", "DnameHolder": "abc", "DReg": "123", "action": "test name", "comments": "" },
    { "srNo": 4, "Dname": "abc.com", "entityName": "TML", "country": "India", "DnameHolder": "abc", "DReg": "123", "action": "test name", "comments": "" },
    { "srNo": 5, "Dname": "abc.com", "entityName": "TML", "country": "India", "DnameHolder": "abc", "DReg": "123", "action": "test name", "comments": "" },
    { "srNo": 1, "Dname": "abc.com", "entityName": "TMPV", "country": "India", "DnameHolder": "abc", "DReg": "123", "action": "test name", "comments": "" },
    { "srNo": 2, "Dname": "def.com", "entityName": "TMCV", "country": "India", "DnameHolder": "abc", "DReg": "123", "action": "test name", "comments": "" },
    { "srNo": 3, "Dname": "abc.com", "entityName": "TML", "country": "India", "DnameHolder": "abc", "DReg": "123", "action": "test name", "comments": "" },
    { "srNo": 4, "Dname": "abc.com", "entityName": "TML", "country": "India", "DnameHolder": "abc", "DReg": "123", "action": "test name", "comments": "" },
    { "srNo": 5, "Dname": "abc.com", "entityName": "TML", "country": "India", "DnameHolder": "abc", "DReg": "123", "action": "test name", "comments": "" },
    { "srNo": 1, "Dname": "abc.com", "entityName": "TMPV", "country": "India", "DnameHolder": "abc", "DReg": "123", "action": "test name", "comments": "" },
    { "srNo": 2, "Dname": "def.com", "entityName": "TMCV", "country": "India", "DnameHolder": "abc", "DReg": "123", "action": "test name", "comments": "" },
    { "srNo": 3, "Dname": "abc.com", "entityName": "TML", "country": "India", "DnameHolder": "abc", "DReg": "123", "action": "test name", "comments": "" },
    { "srNo": 4, "Dname": "abc.com", "entityName": "TML", "country": "India", "DnameHolder": "abc", "DReg": "123", "action": "test name", "comments": "" },
    { "srNo": 5, "Dname": "abc.com", "entityName": "TML", "country": "India", "DnameHolder": "abc", "DReg": "123", "action": "test name", "comments": "" },
  ];

  const handlePageChange = (page) => {
    setSelectedPage(page);
    console.log(`Selected page: ${page}`);
  };

  const [dataLoading, setdataLoading] = useState(false);

  return (
    <>
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
          {/* <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Entity</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={entity}
                onChange={setEntity}
                options={entityOptions}
                isSearchable={false}
              />
            </div>
          </div> */}
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Year</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={year}
                onChange={setYear}
                options={yearOptions}
                isSearchable={false}
              />
            </div>
          </div>

          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Month</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={month}
                onChange={setMonth}
                options={monthOptions}
                isSearchable={false}
              />
            </div>
          </div>

          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Week</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={week}
                onChange={setWeek}
                options={WeekOptions}
                isSearchable={false}
              />
            </div>
          </div>

          <div className="filter-panel-col action-buttons">
            <button onClick={handleApply} className="btn apply-btn">
              Apply
            </button>
            <button onClick={handleReset} className="btn reset-btn">
              Reset
            </button>
          </div>
        </div>
      </div>
      <div>
        <div className="row" >
          <div className="col-md-12">
            <DomainTile title='Bank Reconciliation' showBackButton={true} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <DashboardSection title="" disableDetailView={true}>
              {/* <h2> tabel here</h2> */}
              <ReusableTable
                data={data} columns={columns} itemsPerPage={itemsPerPage} onPageChange={handlePageChange} isCustomOpen={true} totalRecords={totalRecords} handleCSVDownload={handleCSVDownload} dataLoading={dataLoading}
              />
            </DashboardSection>
          </div>
        </div>
      </div>
    </>
  );
};

export default AgratasBankReconcilation;
